<script>
import modal from '@/components/modal';
import store from '../store/index.js';
export default {
    data() {
        return {
            params: {
                title: '询价成功'
            }
        }
    },
    methods: {
        format(_price, decimals = 0) {
            if (!_price) {
                return '**';
            }
            let price = _price / 10000 + '';
            if (decimals > 0) {
                const arr = price.split('.');
                const length = arr[1] ? arr[1].length : 0;
                let complement = decimals - length;
                while (complement) {
                    if (complement < 0) {
                        arr[1] = arr[1].replace(arr[1].charAt(arr[1].length - 1), '');
                        complement++;
                        continue;
                    } else {
                        if (!arr[1]) {
                            arr[1] = '0';
                        } else {
                            arr[1] += '0';
                        }
                    }
                    complement--;
                }
                price = arr.join('.');
            }
            return price;
        },
        show() {
            this.$refs.modal.show();
        },
        click() {
            this.$refs.modal.hide();
            // 重置用户信息
            store.form.mobile = '';
            store.form.name = '';
        }
    },
    computed: {
        lowerPrice() {
            return store.price.lower.lastMonthDealPrice;
        },
        normalPrice() {
            return store.price.normal.price;
        }
    },
    components: {
        modal
    }
}
</script>

<template>
    <modal ref="modal">
        <div class="success-container">
            <div class="success-inner">
                <div class="header">
                    <div class="header-title">
                        <img src="../../assets/success.png" alt="">
                        <h4>询价成功</h4>
                    </div>
                    <div class="tips">我们将及时为您报价</div>
                </div>
                <div class="content" v-if="lowerPrice">
                    <span>最新成交参考价</span>
                    <h3>{{this.format(lowerPrice, 2) + '万元'}}</h3>
                </div>
                <div class="content" v-else>
                    <span>厂商指导价</span>
                    <h3>{{this.format(normalPrice, 2) + '万元'}}</h3>
                </div>
                <div class="button" @click="click">继续咨询</div>
            </div>
        </div>
    </modal>
</template>

<style lang="stylus" scoped>
.success-container
    display flex
    justify-content center
    align-items center
    width 100%
    height 100%
.success-inner
    width 16rem
    border-radius 0.746rem
    background-color #fff
.header 
    margin 0 0.53rem
    padding 1.6rem 0 1.06rem
    text-align center
    border-bottom 0.053rem solid #ebebeb
    &-title
        position relative
        display inline-block
        padding-left 1.6rem
    &-title img
        position absolute
        top 0
        left 0
        bottom 0
        margin auto
        width 1.173rem
        height 1.173rem
    &-title h4
        display inline-block
        line-height 1.4
        font-size 1.06rem
        font-weight 600
        text-align center
        color #111e36
    .tips
        margin-top 0.53rem;
        line-height 1.2
        font-size 0.9rem
        color #111e36
.content
    padding 1.06rem 0 2.12rem
    text-align center
    span
        font-size 0.64rem
        color #666d7f
    h3
        margin-top 0.32rem
        font-size 1.55rem
        line-height 1.2
        font-weight bold
        color #ff6600
.button
    margin 0 auto 1.38rem
    width 12.53rem 
    height 2.346rem
    line-height 2.346rem
    text-align center
    font-size 0.853rem
    border-radius 1.173rem
    background linear-gradient(135deg,rgba(255,168,0,1) 0%,rgba(255,60,0,1) 100%)
    color #fff
</style>